$(function () {
  $('.floating-labels .form-control').on('focus blur', function (e) {
    $(this).parents('.form-group').not('.nofloating').toggleClass('focused', (e.type === 'focus' || (this.value !== undefined && this.value.length > 0)));
  }).trigger('blur');

  //other_choiceが存在する場合、その値を各設問の親divタグにdataとして埋め込む
  $('.other_value').each(function () {
    $(this).parents('.form-group').attr('data-other', $(this).val());
  });

  //ラジオボタンの状態が変化した場合のイベントを付加
  //other_choiceの項目がクリックされた場合、その要素の兄弟要素inputを非活性にする
  $('.form-group').each(function () {
    if ($(this).attr('data-other')) {
      var other_val = $(this).attr('data-other');
      $(this).find('.radio').on('change', function () {
        var parent = $(this).parents('.form-group');
        if (other_val == $(this).val()) {
          parent.find('.other_input').prop('disabled', false);
        } else {
          parent.find('.other_input').prop('disabled', true);
        }
      });
    }
  });

  //checkboxの状態が変化した場合のイベントを付加
  //other_choiceの項目がクリックされた場合、その要素の兄弟要素inputを非活性にする
  $('.other_checkbox').on('change', function () {
    if ($(this).prop('checked')) {
      $(this).nextAll('.other_input').prop('disabled', false);
    } else {
      $(this).nextAll('.other_input').prop('disabled', true);
    }
  });


  //連動設問制御
  function interlockControl(eventIssuer) {
    const selectedAnswer = getSelectedAnswer(eventIssuer);
    const selectedValue = eventIssuer.val();
    const oldValueList = getDataOldValueList(eventIssuer);
    //連動設問情報取得
    const selectedInterlockRecords = filterInterlockRecords(selectedAnswer.interlockQuestions, selectedValue);
    switch (selectedAnswer.question.choice_kind) {
      case '2':
        controlRadioProc(selectedAnswer, oldValueList, selectedInterlockRecords);
        break;
      case '3':
        controlCheckboxProc(eventIssuer, selectedAnswer, oldValueList, selectedInterlockRecords);
        break;
    }
  }

  function controlRadioProc(selectedAnswer, oldValueList, selectedInterlockRecords) {
    const oldInterlockRecords = filterInterlockRecords(selectedAnswer.interlockQuestions, oldValueList[0]);
    //連動設問への制御を解除
    $.each(oldInterlockRecords, function (i, record) {
      controlReleaseProc(record.target_question_id);
    });
    //連動設問への制御を付加
    $.each(selectedInterlockRecords, function (i, record) {
      addControlProc(record.target_question_id, selectedAnswer.question.id);
    });
  }

  function controlCheckboxProc(eventIssuer, selectedAnswer, oldValueList, selectedInterlockRecords) {
    if (eventIssuer.prop('checked')) {
      //連動設問への制御を付加
      // t_question_select_actionsの他のselect_valueのchecked属性が1つだけtrueなら表示処理を走らせる
      $.each(selectedInterlockRecords, function (_, record) {
        let checkedInterlockQuestionCount = 0;
        $.each(record.answer_options, (_, value) => {
          checkedInterlockQuestionCount += $(`input[value="${value}"][id^="${record.answer_question_id}_"]`).prop("checked") ? 1 : 0;
        })
        if (checkedInterlockQuestionCount === 1) {
          addControlProc(record.target_question_id, selectedAnswer.question.id);
        }
      });
    } else {
      // t_question_select_actionsの他のselect_valueのchecked属性がすべてfalseなら連動して非表示にする
      $.each(selectedInterlockRecords, function (_, record) {
        let hasCheckedInterlockQuestion = false;
        $.each(record.answer_options, (_, value) => {
          hasCheckedInterlockQuestion = hasCheckedInterlockQuestion || $(`input[value="${value}"][id^="${record.answer_question_id}_"]`).prop("checked");
        })
        if (!hasCheckedInterlockQuestion) {
          controlReleaseProc(record.target_question_id);
        }
      });
    }
  }

  //クエスチョンＩＤを取得する
  //取得もとは対象のobjectの親に当たるＤＩＶのdata属性より
  function get_question_id(obj) {
    return obj.parents('.form-group').data('question-id');
  }

  function getSelectedAnswer(obj) {
    return selectedAnswers[obj.parents('.form-group').data('question-id')];
  }

  //連動設問に対して制御を実行
  function addControl(controlTargetEl) {
    controlTargetEl.removeClass('hide');
    controlTargetEl.find('input').prop('disabled', false);
    // textareaを活性化するが、「その他」の自由記載欄は初期状態では非活性のため除外する
    controlTargetEl.find('textarea').not('.other_input').prop('disabled', false);
  }

  // 連動設問制御付加プロセス
  function addControlProc(interlockQuestionIds, clickedQuestionId) {
    $.each(interlockQuestionIds, (_, item) => {
      const controlTargetParentObj = $(`.form-group[data-question-id=${item}]`);
      addControl(controlTargetParentObj, clickedQuestionId);
      recursionAddControlProc(controlTargetParentObj)
    });
  }

  function recursionAddControlProc(controlTargetParentObj) {
    const oldValueList =
      controlTargetParentObj.attr('data-old-value') !== '' ?
        controlTargetParentObj.attr('data-old-value').split(',') :
        [];
    $.each(oldValueList, (_, oldValue) => {
      const checkedInterlockEls = $("input[value=oldValue]");
      $.each(checkedInterlockEls, (_, checkedInterlockEl) => {
        interlockControl($(`#${checkedInterlockEl.id}`));
        updateSelectedAnswerList($(`#${checkedInterlockEl.id}`));
      })
    })
  }

  // 連動設問制御解除プロセス
  function controlReleaseProc(interlockQuestionIds) {
    $.each(interlockQuestionIds, async function (_, item) {
      const controlTargetParentObj = $(`.form-group[data-question-id=${item}]`);
      recursionControlReleaseProc(controlTargetParentObj);
      controlRelease(controlTargetParentObj);
    });
  }

  function recursionControlReleaseProc(controlTargetObj) {
    const questionId = parseInt(controlTargetObj.data('question-id'));
    const interlockQuestions = selectedAnswers[questionId].interlockQuestions;
    const oldValue = controlTargetObj.attr('data-old-value');
    const oldValueList = oldValue === undefined ? [] : oldValue.split(',');
    $.each(oldValueList, (_, oldValue) => {
      const interlockRecords = filterInterlockRecords(interlockQuestions, oldValue);
      $.each(interlockRecords, function (_, record) {
        if (hasCheckedInterlockQuestion(record)) {
          controlReleaseProc(record.target_question_id);
        }
      });
    })
  }

  //連動設問に対して制御を解除
  function controlRelease(controlTargetEl) {
    const questionId = controlTargetEl.data('question-id');
    controlTargetEl.addClass('hide');
    $.each(selectedAnswers[questionId].selectedAnswerList, (_, selectedAnswer) => {
      controlTargetEl.find(`input[value="${selectedAnswer}"]`).prop('checked', false);
    })
    controlTargetEl.find('input').prop('disabled', true);
    controlTargetEl.find('textarea').prop('disabled', true);
  }

  // 連動する設問にチェックが入っているか判定する
  function hasCheckedInterlockQuestion(record) {
    let hasCheckedInterlockQuestion = false;
    let answer_question_id = record.answer_question_id
    // 別の設問に同じ選択肢がある場合を考慮して、question_idを指定する
    $.each(record.answer_options, (_, value) => {
      hasCheckedInterlockQuestion = hasCheckedInterlockQuestion || $(`.form-group[data-question-id=${answer_question_id}]`).find($(`input[value="${value}"]`)).prop("checked")
    })
    return hasCheckedInterlockQuestion
  }

  function filterInterlockRecords(interlockQuestions, selectedValue) {
    return $.grep(interlockQuestions, function (record, _) {
      return (record.answer_options.includes(selectedValue));
    });
  }

  function getDataOldValue(targetObj) {
    return targetObj.parents('.form-group').attr('data-old-value');
  }

  function getDataOldValueList(targetObj) {
    if (getDataOldValue(targetObj) === undefined) return [];
    return getDataOldValue(targetObj).split(',');
  }

  function updateDataOldValue(targetObj) {
    const questionId = get_question_id(targetObj);
    targetObj.parents('.form-group').attr('data-old-value', selectedAnswers[questionId].selectedAnswerList.join(","));
  }

  function updateSelectedAnswerList(targetInputEl) {
    const oldValueList = getDataOldValueList(targetInputEl);
    const newValue = targetInputEl.val();
    const {question, selectedAnswerList, _} = getSelectedAnswer(targetInputEl);
    const newSelectedAnswers = Object.assign({}, selectedAnswers);
    switch (question.choice_kind) {
      // ラジオボタン
      case "2":
        if (selectedAnswerList.length > 0 && oldValueList.length !== 0) {
          newSelectedAnswers[`${question.id}`].selectedAnswerList =
            selectedAnswerList.filter(val => !oldValueList.includes(val));
        }
        if (newValue.length > 0) {
          newSelectedAnswers[`${question.id}`].selectedAnswerList = [
            ...new Set(newSelectedAnswers[`${question.id}`].selectedAnswerList.concat(newValue))
          ];
        }
        break;
      // チェックボックス
      case "3":
        if (newValue === '') break;
        if (selectedAnswerList.includes(newValue)) {
          newSelectedAnswers[`${question.id}`].selectedAnswerList.splice(
            selectedAnswerList.indexOf(newValue), 1
          );
        } else {
          newSelectedAnswers[`${question.id}`].selectedAnswerList.push(newValue);
        }
    }
    selectedAnswers = Object.assign({}, newSelectedAnswers);
  }

  //ラジオボタンの状態が変化した場合に連動設問制御を実行
  $('.radio').each(function () {
    $(this).on('change', async function () {
      interlockControl($(this));
      await updateSelectedAnswerList($(this))
      updateDataOldValue($(this));
    });
    // フォームを戻って入力情報を復元した際、チェック済みだった場合は連動質問制御を発火させる
    if ($(this).attr("checked")) {
      $(this).change();
    }
  });

  //チェックボックスの状態が変化した場合に連動設問制御を実行
  $('input.checkbox').each(function () {
    $(this).on('change', async function () {
      await updateSelectedAnswerList($(this));
      interlockControl($(this));
      updateDataOldValue($(this));
    });
    // フォームを戻って入力情報を復元した際、チェック済みだった場合は連動質問制御を発火させる
    if ($(this).attr("checked")) {
      $(this).change();
    }
  });

  // 初期表示時、非表示の連動設問のフォーム要素を無効化して送信を防止
  $('.form-group.hide[data-question-id]').find('input, textarea').prop('disabled', true);
});
